import React from 'react'

export default function IconTick({className}) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M16.0625 0.5625L5.6 12.0656L2.5625 9.75938H0.875L5.6 17.4375L17.75 0.5625H16.0625Z" fill="currentColor"/>
    </svg>
  )
}
